import { useState } from "react";
import emailjs from "emailjs-com";
import Footer from "./Footer";
import { setting } from "../Config/Config";
import { useRef } from "react";
const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [query, setQuery] = useState();
  const form = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
    setQuery(
      `mailto:info@zippylink.net?from=${email}?subject=${name}&body=${message}`
    );
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);
    console.log("form.current: ", form.current);
    const emailData = {
      to_name: "Zippylink",
      from_email: email,
      from_name: name,
      message: message,
    };
    emailjs
      .send(
        "service_27zrgxp",
        "template_3ozuz8m",
        emailData,
        "xh9XePJeyVodg7XPD"
      )
      .then(
        (result) => {
          alert("Email Sent Successfully!");
          console.log(result.text);
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2
                  style={{
                    color: setting.orange,
                  }}
                >
                  Get In Touch
                </h2>
                <p
                  style={{
                    color: setting.orange,
                  }}
                >
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form
                ref={form}
                name="sentMessage"
                validate
                onSubmit={handleSubmit}
              >
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        style={{
                          background: "none",
                          borderColor: setting.orange,
                          color: setting.orange,
                        }}
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        style={{
                          background: "none",
                          borderColor: setting.orange,
                          color: setting.orange,
                        }}
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />

                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    style={{
                      background: "none",
                      borderColor: setting.orange,
                      color: setting.orange,
                    }}
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button
                  type="submit"
                  className="btn btn-custom btn-lg"
                  style={{
                    background: setting.orange,
                    borderColor: setting.orange,
                  }}
                >
                  Send Query
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            {/* <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div> */}
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>
                <a href={query} style={{ color: setting.white }}>
                  {props.data ? props.data.email : "loading"}
                </a>
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i
                        className="fa fa-facebook"
                        style={{ borderColor: setting.orange }}
                      ></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.linkedin : "/"}>
                      <i
                        className="fa fa-linkedin"
                        style={{ borderColor: setting.orange }}
                      ></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i
                        className="fa fa-youtube"
                        style={{ borderColor: setting.orange }}
                      ></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
